import React,{Component} from 'react';

import {
  Col,
  Row,
  Table
} from 'reactstrap';

import Button from '../../../shared/components/Button';
import SortableTable from '../../../shared/components/SortableTable';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import MoneyInput from '../../../shared/components/MoneyInput';

import moment from 'moment';

import { emojiUrlForRating } from '../../../shared/utils';

class RetailerUserView extends Component {
  componentDidMount(){
    Promise.all([
      this.props.loadAppUser(this.props.appUserId),
      this.props.loadLoyaltyBalance(this.props.appUserId)
    ])
  }

  render(){
    const {
      retailerId,
      retailerName,
      loyaltyId,
      timelineItems,
      loyaltyBuffer,
      queryBuffer,
      loyaltyBalance,
      queryBalance,
      lifetimeUse
    } = this.props;

    return (
      <div>
        <Row>
          <Col xs='12'>
            <Button
              linkHref={`/superadmin/retailers/${retailerId}/users`}
              textColor='black'
              backgroundColor='transparent'
            >
              <i className='fa fa-long-arrow-left' aria-hidden='true'></i>
              &nbsp;&nbsp;Back to {retailerName} App Users
            </Button>
            <br />
            <br />
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='6'>
            <h4>User Details</h4>
            <br />
            <Table>
              <tbody>
                <tr>
                  <th>Loyalty ID</th>
                  <td>
                    {loyaltyId}
                  </td>
                </tr>
                <tr>
                  <th>Buffer</th>
                  <td>
                    <MoneyDisplay>{queryBuffer}</MoneyDisplay>
                    {queryBuffer !== loyaltyBuffer && (
                      <span>&nbsp;&nbsp;Loyalty mismatch</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Card</th>
                  <td>
                    <MoneyDisplay>{queryBalance}</MoneyDisplay>
                    {queryBalance !== loyaltyBalance && (
                      <span>&nbsp;&nbsp;Loyalty mismatch</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Lifetime</th>
                  <td>
                    <MoneyDisplay>{lifetimeUse}</MoneyDisplay>
                  </td>
                </tr>
              </tbody>
            </Table>
            <br />
            <br />
          </Col>
          <Col xs='6'>
            <h4>Repair</h4>
            <br />
            <p>
              Some issues result from inconsistencies between the loyalty service and the app data service.  This button will synchronize both services
            </p>
            <Button
              disabled
              size='sm'
            >
              Sync All Services
            </Button>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              Feature not available yet
            </span>
            <br />
            <br />
            <Row>
              <Col xs='6'>
                <MoneyInput />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <h4>Timeline</h4>
            <SortableTable
              columns={[
                {name:'Date', width:25, sortable:false},
                {name:'Event', width:75, sortable:false},
              ]}
            >
              {timelineItems.map((i,idx) => (
                <tr key={idx}>
                  <td>{moment(i.timestamp).format('h:mm a, MMM D, YYYY')}</td>
                  <td>
                    {i.timelineKind === 'signup' && (
                      <span>
                        <strong>User signed up</strong>
                      </span>
                    )}

                    {i.timelineKind === 'response'  && i.engagementKind === 'choose' && (
                    <span>
                      Responded to <strong>"{i.engagementText}"</strong> from <strong>{i.brandName}</strong> with
                      &nbsp;<strong>"{i.answerText}"</strong>
                    </span>
                    )}

                    {i.timelineKind === 'response'  && i.engagementKind === 'ratable' && (
                    <span>
                      Responded to a <strong>Video</strong> from <strong>{i.brandName}</strong> with
                      <strong>&nbsp;
                        "<i className={`fa fa-thumbs-o-${i.answerText === "1" ?"up" :"down"}`} />"
                      </strong>
                    </span>
                    )}

                    {i.timelineKind === 'response' && i.engagementKind === 'this_or_that' && (
                      <span>
                        Responded to a <strong>This or That</strong> from <strong>{i.brandName}</strong> with
                        <strong>&nbsp;{i.answerText === "1" ? '"This"':'"That"'}</strong>
                      </span>
                    )}

                    {i.timelineKind === 'completion' && (
                      <span>
                        Completed <strong>{i.campaignName}</strong>, rated it
                        <strong>&nbsp;"
                          <img
                            style={{
                              height:15,
                              verticalAlign:'text-top'
                            }}
                            alt='rating emoji'
                            src={emojiUrlForRating(i.userRating + 1)}
                          />
                        ",&nbsp;</strong>
                        and earned <strong><MoneyDisplay>{i.rewardEarned}</MoneyDisplay></strong>
                      </span>
                    )}

                    {i.timelineKind === 'connection' && (
                      <span>Connected with <strong>{i.name}</strong></span>
                    )}
                  </td>
                </tr>
              ))}
            </SortableTable>
          </Col>
        </Row>
      </div>
    )
  }
}

export default RetailerUserView;



// WEBPACK FOOTER //
// ./src/routes/RetailerUserView/components/RetailerUserView.js